import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Login, Tokens } from 'src/app/features/login/login';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LoginService } from '../login.service';
import { Subject, takeUntil } from 'rxjs';
import { CryptHelperService } from 'src/app/services/helpers/crypt-helper.service';
import { environment } from 'src/environments/environment';
import { trigger, transition, style, animate } from '@angular/animations';
//import { MSAL_GUARD_CONFIG, MsalBroadcastConfiguration, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
//import { loginenticationResult, EventMessage, EventType, InteractionStatus, PopupRequest } from '@azure/msal-browser';


@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss', '../login.component.scss'],
    animations: [
        trigger('slideDownUp', [
            transition(':enter', [
                style({ overflow: 'hidden', opacity: 0 }),
                animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 1 })),
            ]),
            transition(':leave', [
                style({ overflow: 'hidden', opacity: 1 }),
                animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 0 })),
            ]),
        ]),
    ]
    //providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },ReCaptchaV3Service],
    ,
    standalone: false
})
export class LoginFormComponent implements OnInit, AfterViewInit, OnDestroy {

  // create strict typed angular form, preaty neat
  formLogin = new FormGroup({
    email: new FormControl<string>('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.minLength(1),
    ]),
    password: new FormControl<string>('', [
      Validators.required,
      Validators.minLength(1),
    ]),
  });

  decryped: string = '';
  parsed: number[] = [];

  formHaveErrors: boolean = false;
  passwIcon: string = 'e-icons cursor-pointer spass';
  errMsg: string = '';
  // pop up disconect
  public dialog: any;
  loading: boolean = false;

  logoSpinner: string = `${environment.baseHREF}${environment.logo}`;

  // unsubscribe subscription
  private theEnd$ = new Subject<void>();

  secondsRemaining$: any;

  token: string = '';

  testTimer: string = '';
  showTimer: boolean = false;

  isIframe = false;
  loginDisplay = false;

  microsoftUrl: string = environment.logoMicrosoft;
  logoChange: boolean = false;
  microsoftError: boolean = false;
  showRegisteredMessagge: boolean = false;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private crypter: CryptHelperService,
  ) {
    this.passwIcon += ' e-eye';
    
  }
  ngAfterViewInit(): void {
    // let refresh = localStorage.getItem('refresh');
    // if (refresh) {
    //   location.reload();
    //   localStorage.removeItem('refresh')
    // }

    // setTimeout(() => {
    //   // get url parameters
    //   let kickedOut: string | null;
    //   let expiredToken: string | null;
    //   kickedOut = this.route.snapshot.paramMap.get('newConn');

    //   expiredToken = this.route.snapshot.params['tokenExpired'];
    //   console.warn(kickedOut);

    //   if (kickedOut != null) {
    //     this.errMsg = "Disconesso, qualcuno ha eseguito l'accesso con questo account su un'altra macchina!";
    //     this.formHaveErrors = true;
    //   }

    //   if (expiredToken != null) {
    //     this.errMsg = "La sessione è scaduta, effettua il login per continuare";
    //     this.formHaveErrors = true;
    //   }
    // }, 0)



    // console.log(refresh);
    // this.localStorageService.addValue("SomeCrazyShit", "WOW");
  }


  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  showPassword() {
    const pwdI = document.getElementById('pwdInput');
    if (this.passwIcon.includes('-slash')) {
      this.passwIcon = this.passwIcon.replace('-slash', '');
      pwdI?.setAttribute('type', 'password');
      console.log('removed slash');
    } else {
      this.passwIcon += '-slash';
      pwdI?.setAttribute('type', 'text');
      console.log('added slash');
    }
  }

  login() {
    this.loading = true;

    if (this.formLogin.invalid) {
      this.errMsg = 'I campi username e password sono obbligatori';
      this.formHaveErrors = true;
      this.loading = false;
      return;
    }

    console.log('Starting user login');

    let loginData: Login = {
      email: this.formLogin.value.email || '',
      password: this.formLogin.value.password || '',
    };


    if (loginData.email == '' || loginData.password == '') {
      this.errMsg =
        'Compila tutti i campi per procedere';
      this.formHaveErrors = true;
      this.loading = false;
      return;
    }

    this.loginService.login(loginData).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (response: Tokens) => {

        this.localStorageService.saveTokens(response)
        
        
        this.router.navigate(['/home/dashboard']);
      },
      error: (response: any) => {
        this.loading = false;
      },
    });
  }




  loginM() {



    /*this.MsalService.loginPopup()
    .subscribe({
      next: (res: any) => {
        console.warn("\n \n THIS IS THE RES FROM MICSOF \n \n ");
        console.warn(res);
      },
      error: (res: any) => {
        console.error("\n \n GODAMN MICSOF LOGIN DID NOT WORK \n \n");
        console.error(res);
      }
    });*/
  }

  setLoginDisplay() {
    //this.loginDisplay = this.MsalService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    /*let activeAccount = this.MsalService.instance.getActiveAccount();

    if (!activeAccount && this.MsalService.instance.getAllAccounts().length > 0) {
      let accounts = this.MsalService.instance.getAllAccounts();
      this.MsalService.instance.setActiveAccount(accounts[0]);
    }*/
  }

  /*loginPopup() {
    this.loading = true;
    this.microsoftError = false;
    this.MsalService.loginPopup()
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: loginenticationResult) => {
          this.MsalService.instance.setActiveAccount(response.account);
          console.warn("LOGIN DONE");
          console.warn(response);

          let loginReq: MicrosoftloginLoginRequest = {
            email: response.account.username,
            token: response.idToken,
            username: response.account.name ?? '',
            homeAccountId: response.account.homeAccountId,
            localAccountId: response.account.localAccountId,
          };

          console.warn("THIS IS REQUEST");
          console.warn(loginReq);


          this.MicrosoftService.loginMicrosoft(loginReq).pipe(takeUntil(this.theEnd$)).subscribe({
            next: (risp: LoginResponse) => {

              if (risp.response.success == true) {

                // if the user does not have any role dotn redirect him
                if (risp.user.roles.length == 0) {
                  this.showRegisteredMessagge = true;


                } else {

                  this.localStorageService.saveSession(risp);
                  this.store.dispatch(new userActions.Login({
                    userId: risp.user.userId,
                    username: risp.user.username,
                    roles: risp.user.roles,
                    rolesId: risp.user.rolesId,
                    filiali: risp.user.filiali,
                    password: risp.user.password,
                    creationDate: risp.user.creationDate,
                    email: risp.user.email,
                    surname: risp.user.surname,
                    active: risp.user.active,
                    loginorized: risp.user.loginorized,
                    checking: false,
                    neverLogged: false,
                  }));

                  this.sidebarService.getAllModules(risp.user.userId || 0).pipe(takeUntil(this.theEnd$)).subscribe({
                    next: (value: ModuleBaseResponse) => {
                      localStorage.setItem('M', this.localStorageService.encrypt(JSON.stringify(value.menu)));
                      this.localStorageService.menuReady$.next(true);
                    }
                  })

                  this.loading = false;
                  //this.dialog.hide();
                  //this.loginService.fetchData.emit("LOGIN")

                  this.router.navigate(['/home/dashboard']);

                }

              } else {
                console.error("NO LOGIN");
                console.error(risp);
              }
              this.loading = false;
              this.logoChange = false;
            },
            error: (risp: any) => {
              console.error("NO LOGIN");
              console.error(risp);
              this.loading = false;
              this.logoChange = false;
              this.microsoftError = true;
            }
          })
        },
        error: (err) => {
          console.error("Error in login");
          console.error(err);
          this.loading = false;
          this.logoChange = false;
          this.microsoftError = true;
        },
      });
  }*/

  /*logoutPopup() {
    this.MsalService.logoutPopup().pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: any) => {
        console.warn("LOGOUT RES");
        console.warn(res);
      }
    });
  }*/
}
